import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { getIsCopilotUIDisabled } from 'owa-mail-copilot-settings/lib/selectors/getIsCopilotUIDisabled';

export function isMyOutlookProductFlightEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isAccountFeatureEnabled('acct-personalos-augloop', mailboxInfo) &&
        !getIsCopilotUIDisabled(mailboxInfo)
    );
}
